function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.09 2.91a.91.91 0 111.82 0v3.635a.91.91 0 01-1.82 0V2.91zm0 14.545a.91.91 0 111.82 0v3.636a.91.91 0 01-1.82 0v-3.636zM4.93 6.215A.91.91 0 116.216 4.93l2.572 2.573a.91.91 0 11-1.285 1.285L4.93 6.216zm10.282 10.282a.91.91 0 111.285-1.285l2.573 2.572a.91.91 0 11-1.286 1.286l-2.572-2.573zM2.909 12.91a.91.91 0 010-1.818h3.636a.91.91 0 010 1.818H2.91zm14.546 0a.91.91 0 110-1.818h3.636a.91.91 0 010 1.818h-3.636zm-11.24 6.16a.91.91 0 11-1.285-1.286l2.573-2.572a.91.91 0 111.285 1.285L6.216 19.07zM16.498 8.788a.91.91 0 11-1.285-1.285l2.572-2.573a.91.91 0 111.286 1.286l-2.573 2.572z"
});

var SvgLoader = function SvgLoader(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/loader.a16b15be.svg";
export { SvgLoader as ReactComponent };